function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import useMergedRefs from '@restart/hooks/useMergedRefs';
import useEventCallback from '@restart/hooks/useEventCallback';
import useIsomorphicEffect from '@restart/hooks/useIsomorphicEffect';
import React, { useRef, cloneElement, useState } from 'react';
import NoopTransition from './NoopTransition';
import { jsx as _jsx } from "react/jsx-runtime";
export function useTransition(_ref) {
  var inProp = _ref.in,
      onTransition = _ref.onTransition;
  var ref = useRef(null);
  var isInitialRef = useRef(true);
  var handleTransition = useEventCallback(onTransition);
  useIsomorphicEffect(function () {
    if (!ref.current) {
      return undefined;
    }

    var stale = false;
    handleTransition({
      in: inProp,
      element: ref.current,
      initial: isInitialRef.current,
      isStale: function isStale() {
        return stale;
      }
    });
    return function () {
      stale = true;
    };
  }, [inProp, handleTransition]);
  useIsomorphicEffect(function () {
    isInitialRef.current = false; // this is for strict mode

    return function () {
      isInitialRef.current = true;
    };
  }, []);
  return ref;
}
/**
 * Adapts an imperative transition function to a subset of the RTG `<Transition>` component API.
 *
 * ImperativeTransition does not support mounting options or `appear` at the moment, meaning
 * that it always acts like: `mountOnEnter={true} unmountOnExit={true} appear={true}`
 */

export default function ImperativeTransition(_ref2) {
  var children = _ref2.children,
      inProp = _ref2.in,
      onExited = _ref2.onExited,
      onEntered = _ref2.onEntered,
      transition = _ref2.transition;

  var _useState = useState(!inProp),
      _useState2 = _slicedToArray(_useState, 2),
      exited = _useState2[0],
      setExited = _useState2[1]; // TODO: I think this needs to be in an effect


  if (inProp && exited) {
    setExited(false);
  }

  var ref = useTransition({
    in: !!inProp,
    onTransition: function onTransition(options) {
      var onFinish = function onFinish() {
        if (options.isStale()) return;

        if (options.in) {
          onEntered == null ? void 0 : onEntered(options.element, options.initial);
        } else {
          setExited(true);
          onExited == null ? void 0 : onExited(options.element);
        }
      };

      Promise.resolve(transition(options)).then(onFinish, function (error) {
        if (!options.in) setExited(true);
        throw error;
      });
    }
  });
  var combinedRef = useMergedRefs(ref, children.ref);
  return exited && !inProp ? null : /*#__PURE__*/cloneElement(children, {
    ref: combinedRef
  });
}
export function renderTransition(Component, runTransition, props) {
  if (Component) {
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props));
  }

  if (runTransition) {
    return /*#__PURE__*/_jsx(ImperativeTransition, Object.assign({}, props, {
      transition: runTransition
    }));
  }

  return /*#__PURE__*/_jsx(NoopTransition, Object.assign({}, props));
}